import { render, staticRenderFns } from "./sfc-menu.vue?vue&type=template&id=e20f49c6&scoped=true&lang=pug&"
import script from "./sfc-menu.vue?vue&type=script&lang=js&"
export * from "./sfc-menu.vue?vue&type=script&lang=js&"
import style0 from "./sfc-menu.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./sfc-menu.vue?vue&type=style&index=1&id=e20f49c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20f49c6",
  null
  
)

export default component.exports